import React from 'react';
import VendorForm from './VendorForm';

const TorontoForm = () => <VendorForm city="Toronto" />;
export default TorontoForm;